import { BanksList } from "../components/List/BanksList";
import { BanksCreate } from "../components/Create/BanksCreate";
import { BanksEdit } from "../components/Edit/BanksEdit";
import { BanksView } from "../components/View/BanksView";
import { BankOutlined } from "@ant-design/icons";
import { UserRole } from "@root/api.types";
export const BANKS_LIST = {
    path: "/admin/banks",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: BanksList,
    menu: {
        key: "BANKS_LIST",
        label: "management.banks.menu.title",
        icon: BankOutlined,
    },
};
export const BANKS_CREATE = {
    path: "/admin/banks/create",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: BanksCreate,
};
export const BANKS_EDIT = {
    path: "/admin/banks/:id/edit",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: BanksEdit,
};
export const BANKS_VIEW = {
    path: "/admin/banks/:id/view",
    roles: [UserRole.ADMIN, UserRole.ACCOUNTANT, UserRole.SHAREHOLDER],
    component: BanksView,
};
